var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import MousetrapNative from 'mousetrap';
import { Disposable } from '../common';
import { Dom } from '../util';
export class Keyboard extends Disposable {
    constructor(options) {
        super();
        this.options = options;
        const scroller = this.graph.scroller.widget;
        this.container = scroller ? scroller.container : this.graph.container;
        if (options.global) {
            this.target = document;
        }
        else {
            this.target = this.container;
            if (!this.disabled) {
                // ensure the container focusable
                this.target.setAttribute('tabindex', '-1');
            }
            this.graph.on('cell:mousedown', this.focus, this);
            this.graph.on('blank:mousedown', this.focus, this);
        }
        this.mousetrap = new Keyboard.Mousetrap(this.target, this);
    }
    get graph() {
        return this.options.graph;
    }
    get disabled() {
        return this.options.enabled !== true;
    }
    enable() {
        if (this.disabled) {
            this.options.enabled = true;
            this.graph.options.keyboard.enabled = true;
            if (this.target instanceof HTMLElement) {
                this.target.setAttribute('tabindex', '-1');
            }
        }
    }
    disable() {
        if (!this.disabled) {
            this.options.enabled = false;
            this.graph.options.keyboard.enabled = false;
            if (this.target instanceof HTMLElement) {
                this.target.removeAttribute('tabindex');
            }
        }
    }
    on(keys, callback, action) {
        this.mousetrap.bind(this.getKeys(keys), callback, action);
    }
    off(keys, action) {
        this.mousetrap.unbind(this.getKeys(keys), action);
    }
    focus() {
        const target = this.target;
        target.focus();
    }
    getKeys(keys) {
        return (Array.isArray(keys) ? keys : [keys]).map((key) => this.formatkey(key));
    }
    formatkey(key) {
        const formated = key
            .toLowerCase()
            .replace(/\s/g, '')
            .replace('delete', 'del')
            .replace('cmd', 'command');
        if (this.options.format) {
            return this.options.format.call(this.graph, formated);
        }
        return formated;
    }
    isGraphEvent(e) {
        const target = (e.srcElement || e.target);
        if (target) {
            if (target === this.target || target.parentElement === this.target) {
                return true;
            }
            return Dom.contains(this.container, target);
        }
        return false;
    }
    isEnabledForEvent(e) {
        const allowed = !this.disabled && this.isGraphEvent(e);
        if (allowed) {
            if (this.options.guard) {
                return this.options.guard.call(this.graph, e);
            }
        }
        return allowed;
    }
    dispose() {
        this.mousetrap.reset();
    }
}
__decorate([
    Disposable.dispose()
], Keyboard.prototype, "dispose", null);
(function (Keyboard) {
    class Mousetrap extends MousetrapNative {
        constructor(elem, keyboard) {
            super(elem);
            this.keyboard = keyboard;
        }
        stopCallback(e, elem, combo) {
            if (this.keyboard.isEnabledForEvent(e)) {
                return super.stopCallback(e, elem, combo);
            }
            return false;
        }
    }
    Keyboard.Mousetrap = Mousetrap;
})(Keyboard || (Keyboard = {}));
//# sourceMappingURL=keyboard.js.map